import { EnumModuloDTONecessitaFirma } from '@framework/api-client/api/inquiries/schemas/enumModuloDTONecessitaFirma.ts';
import { type IModuleDelegation } from '@framework/frontoffice-submission/module/delegation/DelegationLogic.ts';
import { getModuleTitle } from '@framework/frontoffice-submission/module/getModuleTitle.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Space } from 'antd';
import { type ColumnGroupType, type ColumnType } from 'antd/es/table';
import { DelegationTypeUserTag } from './components/DelegationTypeUserTag.tsx';
import { ModuleListName } from './components/ModuleListName.tsx';

export const delegationColumnBase: Record<
  string,
  ColumnGroupType<IModuleDelegation> | ColumnType<IModuleDelegation>
> = {
  module: {
    title: t('delegation-column-base.moduli', 'Moduli'),
    key: 'submissionModule',
    render: (_, record) => (
      <ModuleListName
        name={getModuleTitle(record.submissionModule)}
        shouldSign={
          record.submissionModule.modulo?.modulo?.necessitaFirma !=
          EnumModuloDTONecessitaFirma.NO
        }
      />
    ),
  },
  delegates: {
    title: t('delegation-column-base.delegati', 'Delegati'),
    key: 'delegates',
    width: 250,
    render: (_, record) => (
      <Space wrap size={[0, 4]}>
        {record.compilation && (
          <DelegationTypeUserTag delegate={record.compilation} />
        )}
        {record.sign && <DelegationTypeUserTag delegate={record.sign} />}
      </Space>
    ),
  },
  viewers: {
    title: t('delegation-column-base.lettura', 'Lettura'),
    key: 'viewers',
    render: (_, record) => (
      <Space wrap size={[0, 4]}>
        {record.view.map(v => (
          <DelegationTypeUserTag delegate={v} key={v.fiscalCode} />
        ))}
      </Space>
    ),
  },
};

export const delegationColumns = [
  delegationColumnBase.module,
  delegationColumnBase.delegates,
  delegationColumnBase.viewers,
];
